import React, { useEffect, useRef } from 'react';

import backgournd from '../../assets/images/background/4.jpg';
import { useDispatch, useSelector } from 'react-redux';
import { getProfile } from '../../store/slices/profileSlice';
import NFTCard from '../../components/nftCard/NFTCard';
import { useNavigate } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { axiosInstance } from '../../api';
import { endpoints } from '../../api/endpoints';
import notify from '../../utils/notify';
import useMetaMask from '../../hooks/metamask';
import Loader from '../../components/loader/Loader';
import './Profile.css';
import { adminWalletAddress } from '../../configs';

const schema = yup.object({
    ethAmount: yup.string().required('Please enter amount'),
});

const Profile = () => {
    const { connect, disconnect, isActive, library, account } = useMetaMask();

    const profileData = useSelector((state) => state.userData.userData);
    const nftData = useSelector((state) => state.userData.nftData);
    const isLoading = useSelector((state) => state.userData.isLoading);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userLoggedIn = useSelector((state) => state.auth.userLoggedIn);
    const addressRef = useRef();
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    });
    useEffect(() => {
        if (!userLoggedIn) {
            navigate('/auth');
        }
    }, [userLoggedIn, navigate]);

    useEffect(() => {
        if (userLoggedIn) {
            dispatch(getProfile());
        }
    }, [dispatch, userLoggedIn]);

    const copyHandler = () => {
        navigator.clipboard.writeText(addressRef.current.innerText);
        notify('Address copied!!!');
    };

    const submitHanlder = async (submittedData) => {
        if (library) {
            let payload = {
                to: adminWalletAddress,
                from: account,
                value: library.utils.toWei(submittedData.ethAmount),
            };
            await library.eth.sendTransaction(payload, function (error, hash) {
                if (!error) {
                    const interval = setInterval(function () {
                        library.eth.getTransactionReceipt(hash, async function (err, rec) {
                            if (rec) {
                                clearInterval(interval);
                                axiosInstance
                                    .post(endpoints.depositEth, submittedData)
                                    .then((res) => {
                                        dispatch(getProfile());
                                        reset();
                                    })
                                    .catch((error) => console.error(error));
                            }
                        });
                    }, 1000);
                } else {
                    console.log('Something went wrong while submitting your transaction:', error);
                }
            });
        }
    };

    if (isLoading) {
        return <Loader />;
    }

    return (
        <div className="no-bottom no-top" id="content">
            <section id="profile_banner" aria-label="section" className="text-light" style={{ backgroundImage: `url("${backgournd}")` }}></section>
            <section aria-label="section" className="d_coll no-top profile-page-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="d_profile profile-img-wrapper">
                                <div className="profile_avatar">
                                    <div className="d_profile_img profile-logo">
                                        <img src={profileData?.profilePic} style={{ marginBottom: '0 !important' }} alt="" />
                                        <i className="fa fa-check"></i>
                                    </div>
                                    <div className="profile_name">
                                        <h4>
                                            {profileData?.name}
                                            <div className="clearfix"></div>
                                            <span id="wallet" className="profile_wallet" ref={addressRef}>
                                                {profileData?.address}
                                            </span>
                                            <button type="button" id="btn_copy" title="Copy Text" onClick={copyHandler}>
                                                Copy
                                            </button>
                                            <div className="text-field">Balance: {profileData?.balance} ETH</div>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="profile-btn-wrap">
                            <div className="form-wrap">
                                <div className="form-block" style={{ textAlign: 'right' }}>
                                    <form onSubmit={handleSubmit(submitHanlder)}>
                                        <div className="d-flex">
                                            <div style={{ display: 'inline-block', marginRight: '5px' }}>
                                                <input
                                                    {...register('ethAmount')}
                                                    type="number"
                                                    step="0.01"
                                                    placeholder="ETH Amount"
                                                    className="form-control mb-0"
                                                />
                                                {errors.ethAmount && <span className="error-msg">{errors.ethAmount.message}</span>}
                                            </div>
                                            <button className="btn-main">Deposit</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="row info-data">
                            {nftData?.map((item, index) => (
                                <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 nft-card-wrap" key={index}>
                                    <NFTCard data={item} />
                                </div>
                            ))}
                            {nftData?.length === 0 && <p>You don't have any NFT.</p>}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Profile;
